import { useTranslation } from 'react-i18next'
import { useUpdateVoucherMutation } from '@/entities/voucher'
import { getApiErrorText } from '@/shared/libs/get-api-error-text'
import { showToast } from '@/shared/libs/toast'
import { StatusToggleWithConfirm } from '@/shared/ui/status-toggle-with-confirm'

interface VoucherStatusToggleProps {
  voucherId: string
  status: 'AVAILABLE' | 'UNAVAILABLE'
}

export function VoucherStatusToggle({ voucherId, status }: VoucherStatusToggleProps) {
  const { t } = useTranslation()
  const updateMutation = useUpdateVoucherMutation()

  async function handleConfirmed() {
    try {
      await updateMutation.mutateAsync({
        id: voucherId,
        payload: { status: status === 'AVAILABLE' ? 'UNAVAILABLE' : 'AVAILABLE' },
      })
      showToast.success(t('voucher.statusUpdateSuccess'))
    } catch (error) {
      showToast.error(getApiErrorText(error) ?? t('common.operationFailed'))
    }
  }

  return (
    <div className="flex justify-center">
      <StatusToggleWithConfirm
        checked={status === 'AVAILABLE'}
        pending={updateMutation.isPending}
        confirmEnableTitle={t('voucher.enableConfirm')}
        confirmDisableTitle={t('voucher.disableConfirm')}
        onConfirmed={handleConfirmed}
      />
    </div>
  )
}
